/** Prize accent tokens — single source for borders, gradients, lines, and future prizes. */
export const PRIZE_ACCENT_COLORS = {
  gold: "#fbbb42",
  silver: "#2257c4",
  bronze: "#d8641e",
  blue: "#3f7fd8",
  purple: "#6252b8",
  green: "#32a87d",
  red: "#e85b6a",
  total: "#ffffff",
};

/** Same gradients as SCSS $gradient-badge-* (circle + badge). */
export const PRIZE_ACCENT_GRADIENTS = {
  gold: { from: "#fbbb42", to: "#d8950a", angle: 219.87 },
  silver: { from: "#2257c4", to: "#1b4aab", angle: 220.25 },
  bronze: { from: "#d8641e", to: "#be5515", angle: 219.73 },
  blue: { from: "#3f7fd8", to: "#2e6bb8", angle: 219.87 },
  purple: { from: "#6252b8", to: "#4a3d96", angle: 219.87 },
  green: { from: "#32a87d", to: "#248a63", angle: 219.87 },
  red: { from: "#e85b6a", to: "#c94352", angle: 219.87 },
};

export const getPrizeAccentColor = (accent) =>
  PRIZE_ACCENT_COLORS[accent] || PRIZE_ACCENT_COLORS.gold;

export const getPrizeAccentGradient = (accent) =>
  PRIZE_ACCENT_GRADIENTS[accent] || PRIZE_ACCENT_GRADIENTS.gold;

/** SVG path from assets/images/line.svg */
export const PRIZE_LINE_PATH =
  "M1 0.000610352C0.734784 -0.0086621 0.48043 0.0885707 0.292893 0.276262C0.105357 0.463643 0 0.726121 0 1.00061C0 1.2751 0.105357 1.53758 0.292893 1.72496C0.48043 1.91265 0.734784 2.00988 1 2.00061C1.48333 1.98394 1.96667 1.96728 2.45 1.95061C11.15 1.65061 19.85 1.35061 28.55 1.05061C29.0333 1.03394 29.5167 1.01728 30 1.00061C29.5167 0.983944 29.0333 0.967277 28.55 0.95061C19.85 0.65061 11.15 0.35061 2.45 0.0506104C1.96667 0.0339437 1.48333 0.017277 1 0.000610352Z";
